export default function ProductListSkeleton() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section Skeleton */}
      <div className="bg-gray-200 animate-pulse">
        <div className="container mx-auto px-4 py-12 sm:py-14">
          <div className="h-8 bg-gray-300 rounded w-1/2 mx-auto mb-4"></div>
          <div className="h-4 bg-gray-300 rounded w-2/3 mx-auto"></div>
        </div>
      </div>

      {/* Product Bands Section Skeleton */}
      <div className="bg-[#0A0A0A] py-10 sm:py-12">
        <div className="h-8 bg-gray-700 rounded w-96 mx-auto mb-10"></div>

        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-gray-800 py-8">
            <div className="container mx-auto px-4">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="h-6 bg-gray-700 rounded w-3/4 mb-4"></div>
                  <div className="h-4 bg-gray-700 rounded w-full mb-2"></div>
                  <div className="h-4 bg-gray-700 rounded w-5/6 mb-4"></div>
                  <div className="space-y-2">
                    <div className="h-3 bg-gray-700 rounded w-2/3"></div>
                    <div className="h-3 bg-gray-700 rounded w-3/4"></div>
                    <div className="h-3 bg-gray-700 rounded w-1/2"></div>
                  </div>
                </div>
                <div className="h-48 bg-gray-700 rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Section Skeleton */}
      <div className="py-10 bg-[#f8f7f4] sm:py-12 md:py-14">
        <div className="container mx-auto">
          <div className="h-96 bg-gray-300 rounded-2xl animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}
